/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Preview_TitleInputs */

const vi_irrigation_schedule_preview_title = /** @type {(inputs: Irrigation_Schedule_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các phiên 7 ngày tới`)
};

/**

* @param {Irrigation_Schedule_Preview_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_preview_title = /** @type {((inputs?: Irrigation_Schedule_Preview_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Preview_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_preview_title(inputs)
});